import {useEffect} from "react";
import {useLexicalComposerContext} from "@lexical/react/LexicalComposerContext";

// initialConfig.editable only applies at construction, so readOnly changes after
// mount (e.g. a panel case flipping mode) need to be applied reactively.
const ReadOnlySyncPlugin = ({readOnly}) =>
{
    const [editor] = useLexicalComposerContext();

    useEffect(() =>
    {
        editor.setEditable(!readOnly);
    }, [editor, readOnly]);

    return null;
}

export {ReadOnlySyncPlugin};
